<!--
 * @Description: 
 * @Author: xiaoHai
 * @Date: 2021-10-13 15:13:47
 * @LastEditTime: 2021-10-13 15:14:14
-->
<template>
  <div>
    <div class="bottom-text">
      <div class="logo-bottom"></div>
      <div class="bottom-right">
        <!-- <div class="bottom-text-center">
          <span style="font-size: 20px">联系我们</span>
          <el-button type="text"  class="go-page" :underline="false"
            >商务合作</el-button>
          <span> &nbsp; </span>
        </div> -->
        <div class="bottom-text-center">
          <span style="font-size: 20px">法律义务</span>
          <el-button type="text" @click="toAgreement">用户协议</el-button>
          <el-button type="text" @click="toPrivacy">隐私协议</el-button>
        </div>
        <div class="bottom-text-center bottom-text-right">
          <!-- <img :src="require('@/common/imgs/wechat.jpg')" alt=""> -->
          <a href="https://beian.miit.gov.cn/" style="color:#ffff;font-size:20px">闽ICP备2022001053号</a> 
          <span>COPYRIGHT ©2022 – 2023 登游科技. ALL RIGHTS RESERVED</span>
          <span>厦门登游科技有限公司 版权所有</span>
        </div>
      </div>
    </div>
    <div class="banquan">
      <p>健康游戏忠告：</p>
      <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
      <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      publicData: [
        {
          // image:
          //   "https://game-cdn.feigo.fun/uploads/20201202/kr1XgRFggXr4FDV9sMvv8EyTKo6bS11i.png",
          // name: "微信公众号",
        },
      ],
    };
  },
  methods: {
    business() {
      this.$router.push("./business");
    },
    toPrivacy(){
      const privacy = this.$router.resolve({ path: "./Privacy" });
      window.open(privacy.href, "_blank");
    },
    toAgreement(){
      const privacy = this.$router.resolve({ path: "./Agreement" });
      window.open(privacy.href, "_blank");
    }

  },
};
</script>
<style src="../css/bottom.css"></style>
